/**
 *
 * @param {Object} coupon
 * @param {string} coupon.id - Firebase coupon id
 * @param {string} coupon.discount - Discount value between 0 and 100
 * @param {string} coupon.code - Coupon code, ex: "TALENTBAIT20"
 * @returns
 */
export function mapCoupon(coupon) {
  const { id, code, item, discount } = coupon;
  const { value, type } = discount;

  const prefix = type === "percent" ? "%" : "EUR";

  return {
    id,
    code,
    type,
    discount: value,
    discountText: `${value} ${prefix}`,
    item
  };
}
